import { ArrowRight, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo5 from "@assets/logos_extracted/5.png";
import logo10 from "@assets/logos_extracted/10.png";
import logo11 from "@assets/logos_extracted/11.png";

const tableData = [
  {
    name: "FastSlots Casino",
    bonus: "200% do 125 000 Kč + 50 FS",
    rating: "4.9/5",
    license: "O. Anjouan",
    initials: "FS",
    color: "#003da5",
    logo: logo5,
    ctaUrl: "#fastslots",
    featured: true,
  },
  {
    name: "Instant Casino",
    bonus: "200% do 190 000 Kč",
    rating: "4.8/5",
    license: "O. Anjouan",
    initials: "IC",
    color: "#7c00a5",
    logo: logo11,
    ctaUrl: "#instant",
    featured: false,
  },
  {
    name: "Golden Panda",
    bonus: "200% až do výše 125 000 Kč + 50 FS",
    rating: "4.6/5",
    license: "O. Anjouan",
    initials: "GP",
    color: "#7a4a00",
    logo: logo10,
    ctaUrl: "#goldenpanda",
    featured: false,
  },
];

export function ComparisonTable() {
  return (
    <section id="porovnat" className="py-16 bg-gray-50" data-testid="section-comparison">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: "linear-gradient(135deg, #003da5, #0060e6)" }}
            >
              <BarChart3 className="w-5 h-5 text-white" />
            </div>
            <h2 className="text-3xl font-black text-gray-900">
              Porovnání nejlepších online kasin
            </h2>
          </div>
          <p className="text-gray-600 leading-relaxed max-w-2xl">
            Rychlý přehled klíčových parametrů pro snadné srovnání. Bonusy, hodnocení a licence na jednom místě.
          </p>
        </div>

        <div
          className="rounded-2xl border border-gray-100 bg-white overflow-hidden shadow-sm"
          data-testid="comparison-table"
        >
          <div className="overflow-x-auto">
            <table className="w-full" style={{ minWidth: "560px" }}>
              <thead>
                <tr
                  className="text-left"
                  style={{ background: "linear-gradient(135deg, #001a4d 0%, #003da5 100%)" }}
                >
                  <th className="py-4 px-4 pl-6 text-white/60 text-xs font-semibold uppercase tracking-wider">Název</th>
                  <th className="py-4 px-4 text-white/60 text-xs font-semibold uppercase tracking-wider">Bonus</th>
                  <th className="py-4 px-4 text-white/60 text-xs font-semibold uppercase tracking-wider">Hodnocení</th>
                  <th className="py-4 px-4 text-white/60 text-xs font-semibold uppercase tracking-wider">Licence</th>
                  <th className="py-4 px-4 pr-6 text-white/60 text-xs font-semibold uppercase tracking-wider">Hrát</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, i) => (
                  <tr
                    key={row.name}
                    className={`border-b border-gray-50 last:border-b-0 transition-colors ${
                      row.featured ? "bg-blue-50/40" : i % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                    }`}
                    data-testid={`comparison-row-${i}`}
                  >
                    <td className="py-10 px-4 pl-6">
                      <div className="flex items-center gap-3">
                        <div
                          className="w-9 h-9 rounded-lg overflow-hidden flex-shrink-0"
                          style={{ background: row.color }}
                        >
                          <img src={row.logo} alt={row.name} className="w-full h-full object-cover" />
                        </div>
                        <span className="font-bold text-gray-900 text-sm">{row.name}</span>
                        {row.featured && (
                          <span className="text-white text-xs font-bold px-2 py-0.5 rounded" style={{ background: "#ff0000", fontSize: "9px" }}>
                            TOP
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="py-10 px-4 text-sm font-semibold text-gray-800">{row.bonus}</td>
                    <td className="py-10 px-4">
                      <span className="text-[#003da5] font-black text-sm">{row.rating}</span>
                    </td>
                    <td className="py-10 px-4 text-sm text-gray-600">{row.license}</td>
                    <td className="py-10 px-4 pr-6">
                      <a href={row.ctaUrl}>
                        <Button
                          size="sm"
                          className={`${row.featured ? "hraj-btn" : "hraj-btn-light"} font-bold text-xs gap-1 ${row.featured ? "text-white" : ""}`}
                          style={row.featured ? { background: "#003da5" } : undefined}
                          variant={row.featured ? "default" : "outline"}
                          data-testid={`button-compare-${i}`}
                        >
                          Hraj
                          <ArrowRight className="hraj-arrow w-3 h-3" />
                        </Button>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="p-4 pl-6 border-t border-gray-50 bg-gray-50/50">
            <p className="text-gray-500 text-xs leading-relaxed">
              Každý z těchto webů je špičkový. Výběr závisí na vašich osobních preferencích a jedinečných vlastnostech jednotlivých platforem.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
